import React from "react";
import useCachedLoadVisibleFeatures from "./useCachedLoadVisibleFeatures";
import useService from "./useService";
import { PersonTypeContext } from "./usePersonType";
import PersonTypeDomainService from "../../Domain/PersonType/PersonType.service";
const usePersonTypeVisibleFeatures = (personTypeInternalNames) => {
    const personTypeContext = React.useContext(PersonTypeContext);
    if (!personTypeContext.internalName && !personTypeInternalNames) {
        (console.error || console.log)(`useStudentTypeVisibleFeatures was used outside of a Person type context without an override and therefore defaulted to ${PersonTypeDomainService.DefaultPersonTypeInternalName}.`);
    }
    else if (!personTypeContext.internalName && personTypeInternalNames) {
        console.warn("This hook is not being used inside a context. This will work with the overriding personTypeInternalName string, but should not be used this way");
    }
    const [visibleFeatures, loadVisibleFeatures] = useService(useCachedLoadVisibleFeatures);
    React.useEffect(() => {
        loadVisibleFeatures(personTypeInternalNames ||
            (personTypeContext.internalName
                ? [personTypeContext.internalName]
                : null) || [PersonTypeDomainService.DefaultPersonTypeInternalName]);
    }, [
        loadVisibleFeatures,
        personTypeContext.internalName,
        personTypeInternalNames,
    ]);
    return visibleFeatures;
};
export default usePersonTypeVisibleFeatures;
